import { Injectable } from '@angular/core';
import { FaIconLibrary, IconDefinition } from '@fortawesome/angular-fontawesome';
import {
  faFacebook,
  faFacebookF,
  faFacebookSquare,
  faLinkedin,
  faLinkedinIn,
  faSquareXTwitter,
  faTwitterSquare,
  faXTwitter
} from '@fortawesome/free-brands-svg-icons';
import { faCrown, faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import {
  faHouse,
  faGift as faGiftLight,
  faAward as faAwardLight,
  faStar as faStarLight,
  faCoins as faCoinsLight,
  faHouse as faHouseLight,
  faXmark as faXmarkLight,
  fal,
  faTrophy,
  faArrowRightFromArc,
  faTrophyStar,
  faUser,
  faShareNodes,
  faClock,
  faFile,
  faCircleInfo,
  faEnvelope,
  faLink,
  faClose,
  faArrowDownToLine,
  faTrashCan,
  faBadgeCheck
} from '@fortawesome/pro-light-svg-icons';
import {
  faAngleLeft,
  faAward,
  faCoins,
  faEye,
  faEyeSlash,
  faGift,
  faTableCellsLarge,
  faTableList,
  faUserGroup
} from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowLeft,
  faArrowRight,
  faBars,
  faBarsFilter,
  faCheck,
  faChevronDown,
  faChevronUp,
  faChevronRight as faChevronRightSolid,
  faCircle,
  faCircle1,
  faCircleCheck,
  faCircleExclamation,
  faEllipsisVertical,
  faImage,
  faSquareEnvelope,
  faStar,
  faXmark
} from '@fortawesome/pro-solid-svg-icons';

@Injectable({
  providedIn: 'root'
})
export class FaIconService {
  constructor(private library: FaIconLibrary) {}

  //Need to add icon to the corresponding category before usage
  private fabIconSet: IconDefinition[] = [
    faLinkedin,
    faTwitterSquare,
    faFacebookSquare,
    faFacebook,
    faLinkedinIn,
    faFacebookF,
    faXTwitter,
    faSquareXTwitter
  ];
  private falIconSet: IconDefinition[] = [
    faHouse,
    faGiftLight,
    faAwardLight,
    faTrophy,
    faArrowRightFromArc,
    faStarLight,
    faTrophyStar,
    faCoinsLight,
    faUser,
    faShareNodes,
    faHouseLight,
    faXmarkLight,
    faClock,
    faFile,
    faCircleInfo,
    faEnvelope,
    faLink,
    faClose,
    faArrowDownToLine,
    faTrashCan,
    faBadgeCheck
  ];
  private fadIconSet: IconDefinition[] = [faCrown, faSpinnerThird];
  private farIconSet: IconDefinition[] = [
    faEye,
    faAward,
    faTableList,
    faTableCellsLarge,
    faCoins,
    faEyeSlash,
    faArrowLeft,
    faAngleLeft,
    faGift,
    faUserGroup
  ];
  private fasIconSet: IconDefinition[] = [
    faBars,
    faBarsFilter,
    faEllipsisVertical,
    faSquareEnvelope,
    faCircleExclamation,
    faChevronUp,
    faChevronDown,
    faChevronRightSolid,
    faImage,
    faCheck,
    faXmark,
    faStar,
    faArrowRight,
    faArrowLeft,
    faCircle1,
    faCircle,
    faCircleCheck
  ];

  setIcons(): void {
    //Currently importing all light icons to support existing functionality untill we find solution
    // this.library.addIcons(...this.falIconSet);
    this.library.addIconPacks(fal);

    this.library.addIcons(...this.fabIconSet);
    this.library.addIcons(...this.farIconSet);
    this.library.addIcons(...this.fasIconSet);
    this.library.addIcons(...this.fadIconSet);
  }
}
